module.exports = __webpack_public_path__ + "media/Barco.705883bb.mp3";